import { Navigate } from 'react-router-dom';

import { usePermissions } from '@/hooks/usePermissions';

import { NotAllowed } from './NotAllowed';

export const Landing = () => {
  const { startingPage } = usePermissions();

  return startingPage ? (
    <Navigate to={startingPage} />
  ) : (
    <NotAllowed
      title="Sem permissão"
      subTitle="Você não tem permissão para acessar nenhum módulo, por favor entre em contato com o Administrador."
      noExtra
    />
  );
};
